"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function LampTable(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M16.595 2c.88 0 1.663.585 1.916 1.426l2.4 8c.377 1.258-.605 2.574-1.918 2.574h-4.097c-.187.979-.604 1.921-.986 2.781-.256.575-.505 1.106-.678 1.524-.173.418-.237.778-.237.695v1h4v2h-10v-2h4v-1c0 .083-.063-.277-.236-.695-.173-.418-.422-.949-.678-1.524-.382-.86-.8-1.802-.986-2.781H4.997c-1.312 0-2.292-1.317-1.916-2.574l2.399-8A2.01 2.01 0 0 1 7.396 2zM12.81 14h-1.63c.17.603.432 1.298.73 1.969l.085.193.086-.193c.298-.671.56-1.366.729-1.969zm3.785-10h-9.2l-2.4 8h14l-2.4-8z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = LampTable;
